import { createTheme } from '@mui/material';
import { blue, yellow } from '@mui/material/colors';
import { enUS, ptBR } from '@material-ui/core/locale';
import env from 'config/env';

const localeSel = (env.language === 'en' ? enUS : ptBR);

const LightTheme = createTheme({
  typography: {
    fontSize: 14,
  },
  spacing: (factor: number) => `${0.25 * factor}rem`,
  palette: {
    primary: {
      main: yellow[600],
      dark: yellow[700],
      light: yellow[400],
      contrastText: '#ffffff',
    },
    secondary: {
      main: blue[800],
      dark: blue[600],
      light: blue[400],
      contrastText: '#ffffff',
    },
    background: {
      paper: '#ffffff',
      default: '#f7f6f3',
    }
  }
},
localeSel,
);

LightTheme.components = {
  MuiAlert: {
    defaultProps: {
      variant: 'filled',
    },
  },
};

export type Theme = typeof LightTheme;

export default LightTheme;